import store from '@/store'
import router from '@/router'
import { ElMessage } from 'element-plus'
import useClipboard from 'vue-clipboard3'
const { toClipboard } = useClipboard()

export function deepClone(target) {
    // 定义一个变量
    let result
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === 'object') {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
            result = [] // 将result赋值为一个数组，并且执行遍历
            for (let i in target) {
                // 递归克隆数组中的每一项
                result.push(deepClone(target[i]))
            }
            // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
            result = null
            // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
            result = target
        } else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {}
            for (let i in target) {
                result[i] = deepClone(target[i])
            }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
        result = target
    }
    // 返回最终结果
    return result
}

function hasPermission(permission) {
    if (store.state.settings.enablePermission) {
        return store.state.user.permissions.some(v => {
            return v === permission
        })
    } else {
        return true
    }
}

export function auth(value) {
    let auth
    if (typeof value === 'string') {
        auth = hasPermission(value)
    } else {
        auth = value.some(item => {
            return hasPermission(item)
        })
    }
    return auth
}

export function authAll(value) {
    const auth = value.every(item => {
        return hasPermission(item)
    })
    return auth
}

export function checkDataType(value) {
    if (value instanceof Array) {
        let result = true
        value.forEach(item => {
            if (!Number(item) && item - 0  !== 0) {
                return result = false
            }
        })
        return result
    } else {
        return value === 0 || Boolean(Number(value))
    }
}
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

export const toType = obj => {
    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

export function filterNull(o) {
    for (let key in o) {
        if (o[key] == null) delete o[key]
        if (toType(o[key]) === 'string') {
            o[key] = o[key].trim()
            if (o[key] === '') delete o[key]
        } else if (toType(o[key]) === 'object') {
            o[key] = filterNull(o[key])
            if (JSON.stringify(o[key]) === '{}') delete o[key]
        } else if (toType(o[key]) === 'array') {
            o[key] = filterNull(o[key])
            o[key] = o[key].filter(arr => arr)
            if (o[key].length === 0) delete o[key]
        }
    }
    return o
}

export const goNewPage = (name, params = {}) => {
    const { href } = router.resolve({ name: name, query: { ...params } })
    window.open(href, '_blank')
}

export const toLogin = redirect => {
    if (!store.getters['user/isLogin']) {
        router.push({
            path: '/login',
            query: {
                redirect: redirect || router.currentRoute.value.fullPath
            }
        })
        return false
    } else {
        return true
    }
}

export const logCount = (cate, title, desc) => {
    const event = desc ? `${cate}-${title}-${desc}` : `${cate}-${title}`
    window.TDAPP && window.TDAPP.onEvent(event)
}

export async function copy(text, tip = '') {
    try {
        await toClipboard(text)
        ElMessage.success(`${tip}已复制到剪贴板`)
    } catch (e) {
        console.error(e)
        ElMessage.error(`${tip}复制失败`)
    }
}

/**
 * 防抖
 * @param {Function} func 执行函数
 * @param {Object} context 获取当前 this
 * @param {Boolean} imme 是否立即执行
 * @param {Number} delay 延迟时间
 * @returns
 */
export const debounce = (func, context, imme, delay = 500) => {
    return (function() {
        if (context?.timeout) {
            clearTimeout(context.timeout)
        }
        if (imme) {
        // 立即执行
            if (!context.timeout) {
                func()
            }
            context.timeout = setTimeout(() => {
                context.timeout = null
            }, delay)
        } else {
        // 非立即执行
            context.timeout = setTimeout(() => {
                func()
                context.timeout = null // 必须要清空，否则影响另一事件
            }, delay)
        }
    })()
}

export function getElementLoadingSvg() {
    return `
    <path class="path" d="
    M 30 15
    L 28 17
    M 25.61 25.61
    A 15 15, 0, 0, 1, 15 30
    A 15 15, 0, 1, 1, 27.99 7.5
    L 15 15
    " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
    `
}
export function isEmptyExcludeZero(val) {
    if (val === 0 || val === '0') return false
    if (!val) return true
    if (Array.isArray(val)) {
        return !val.length
    }
    return false
}

